import React, {useEffect, useState} from 'react';
import {useFetching} from "../../hooks/useFetching";
import {API_ABOUT_FIRST_SECTION} from "../../utils/consts";
import {observer} from "mobx-react-lite";
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import ApiAboutFirstSection from "../../services/About/FirstSection";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import { Parallax, useParallaxController } from 'react-scroll-parallax';
import device from 'current-device'

import parallax1webp from "../../img/about/parallax1.webp";
import parallax1jpg from "../../img/about/parallax1.jpg";
import logo from "../../img/logo.svg";
import Loader from "../Loader";

const FirstSection = ({setLoading}) => {
    const {t} = useTranslation();
    const location = useLocation();
    const supportsWebP = useWebPSupportCheck();
    const parallaxController = useParallaxController();

    const [text, setText] = useState();
    // const [text, setText] = useState('<p>Champion™ - це постачальник найкращих ігрових рішень для грального бізнесу, що включають наземні гральні заклади та онлайн сегмент.</p>');

    const [FunctionApiAboutFirstSection] = useFetching(async () => {
        try {
            const response = await ApiAboutFirstSection.getApiAboutFirstSection(API_ABOUT_FIRST_SECTION);
            setText(response.data.text);
        } catch {
            console.error('FunctionApiAboutFirstSection')
        }
    });

    useEffect(() => {
        FunctionApiAboutFirstSection();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {text ? <div className="up_catalog about_first">
                <div className="back">
                    <Parallax translateY={
                        device.mobile()
                            ? device.landscape()
                                ? ['56px', '-56px']
                                : ['100px', '-100px']
                            : ['143px', '-143px']
                    }>
                        <img
                            className="thumbnail"
                            onLoad={() => {
                                setLoading(false)
                                parallaxController.update();
                            }}
                            src={supportsWebP ? parallax1webp : parallax1jpg}
                            alt="img"
                            style={{transform: 'scale(1.3)'}}
                        />
                    </Parallax>
                </div>
                <div className="title_block">
                    <img src={logo} alt="logo" />
                    {text && parse(text)}
                </div>
                <div className="mouse_bottom">
                    <p>{t('Прогорнути')}</p>
                    <div className="line" />
                </div>
            </div> : <Loader />}
        </>
    );
};

export default observer(FirstSection);